'use strict';

import './searchResultsLink.scss';
import template from './searchResultsLink.template.html';
import controller from './searchResultsLink.controller.js';

const component = {
    bindings: {},
    transclude: true,
    controller,
    template
};

export default component;
